import { useCallback } from 'react'
import { AUTH_PROVIDERS } from '../constants'
import { useExtenalLoginStore } from '../store/useExternalLoginStore'
import { redirectUrl } from './redirectUrl'

interface UseExternalLoginReturn {
  initializeLogin: () => void
}

/**
 * Handles the external login flow.
 * If the user is not logged in and is external login, it will redirect to Auth0.
 * If the user is logged in and is external login, it will redirect to the provider.
 *
 * @param isLoggedIn - Whether the user is logged in
 * @returns Object with loading states and authentication handlers
 */
export function useExternalLogin(isLoggedIn: boolean): UseExternalLoginReturn {
  const { setAuthProvider } = useExtenalLoginStore()

  /**
   * Initialize the login flow
   * Sets the provider and redirects to Auth0 after validating the URL
   * For now, we only support Excel login, so we set the provider to EXCEL
   */
  const initializeLogin = useCallback(() => {
    setAuthProvider(AUTH_PROVIDERS.EXCEL)

    if (!isLoggedIn) {
      const isDevelopmentEnv =
        process.env.NODE_ENV === 'development' || window.location.host.includes('.qa.')
      const baseUrl = isDevelopmentEnv
        ? 'https://tdsc-login.qa.claravine.com'
        : 'https://tdsc-login.claravine.com'
      const clientId = isDevelopmentEnv
        ? 'HlEZROgEQwaKc07rP0afQmjfn434rr0x'
        : 'cCGzsFNFhrX6QXZQaXgD6SicGOeudx0x'
      const audience = isDevelopmentEnv
        ? 'https://dev-internal.claravine.com/api'
        : 'https://claravine.com/api/'
      const subdomain = window.location.host.split('.')[0]
      const redirectUri = AUTH_PROVIDERS.EXCEL.redirectUrl

      const authUrl = `${baseUrl}/login/v1/redirect?response_type=token&scope=openid&client_id=${clientId}&redirect_uri=${redirectUri}&audience=${audience}&subdomain=${subdomain}`
      redirectUrl(authUrl)
    }
  }, [isLoggedIn, setAuthProvider])

  return {
    initializeLogin,
  }
}
